export enum TableSettingsTableTypes {
    ADAPTIVE_AUTHENTICATION = "adaptiveAuthentication",
    ALERT_EVENTS = "alertEvents",
    ATTRIBUTE_LABELS = "attributeLabels",
    AXN_ADMIN_SESSIONS = "axnAdminSessions",
    AXN_SESSIONS = "axnSessions",
    FRAUD_REPORT = "fraudReport",
    IDENTITY_PROVIDERS = "identityProviders",
    MESSAGING_TEMPLATES = "messagingTemplates",
    MESSAGE_TEMPLATES = "messageTemplates",
    ORGANIZATIONS = "organizations",
    ORGANIZATION_ACTIVITY = "organizationActivity",
    ORGANIZATION_INVITATIONS = "organizationInvitations",
    ORGANIZATION_USERS = "organizationUsers",
    ORGANIZATION_USER_ACTIVITIES = "organizationUserActivities",
    POLICY_COMPONENTS = "policyComponents",
    POLICY_COMPONENT_DETAILS_ASSOCIATED_POLICY_COMPONENTS = "policyComponentDetailsAssociatedPolicyComponents",
    RELYING_PARTIES = "relyingParties",
    SECURITY_RULES = "securityRules",
    SERVICE_TEMPLATES = "serviceTemplates",
    SERVICE_ASSERTION_PERFORMANCE = "serviceAssertionPerformance",
    SERVICE_ASSERTION_PERFORMANCE_COMPARISON = "serviceAssertionPerformanceComparison",
    VERIFICATION_SERVICES = "verificationServices",
    VERIFICATION_TRANSACTIONS = "verificationTransactions",
    WORKFLOWS = "workflows",
    WORKFLOW_TEMPLATES = "workflowTemplates"
}